/**
 * Above this, an amount shows whole units only.
 *
 * The ported row carries more than crash's — picks, a multiplier badge, the
 * stake AND the potential win — so a five- or six-figure sum crowds it.
 * Dropping the cents there buys the room back. Crash keeps its cents: its row
 * is sparser and reads fine as-is.
 */
export const CENTS_THRESHOLD = 1000

/**
 * Remove the fractional part of an ALREADY-FORMATTED amount once it is large
 * enough not to need it.
 *
 * TRUNCATES, never rounds. `14,715.99` becomes `14,715`, not `14,716` — a
 * figure that reads HIGHER than the real one is the kind players screenshot
 * and complain about, and the most it ever understates by is 99 cents on a
 * sum of at least a thousand.
 *
 * Operates on the formatted string rather than the number because the fiat
 * formatter pins two decimals, so truncating the value first would still
 * render "4,005.00". Safe to cut on the last `.` — `formatNumber` always emits
 * `.` for the decimal separator and `,` for thousands, with no locale
 * switching.
 *
 * Pass `Infinity` to disable (crash does).
 */
export const dropCents = (
  formatted: string,
  value: number,
  threshold: number = CENTS_THRESHOLD
): string => {
  if (!Number.isFinite(value)) return formatted
  if (Math.abs(value) < threshold) return formatted

  const dot = formatted.lastIndexOf('.')
  if (dot === -1) return formatted

  return formatted.slice(0, dot)
}
